export enum OptionRestrictionBehavior {
  HideOption = 'HideOption',
  DisableWithDescription = 'DisableWithDescription',
  OnlyShowDescription = 'OnlyShowDescription'
}
